import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';

import {
    CalculationLineBlock,
    CalculationPanel,
    CalculatorStepAccordion,
    FormComputed,
    MessagePropType,
    useForm,
    Colours,
} from '@ratehub/base-ui';

import getMonthlyExpensesCalculations, { getMonthlyExpenses } from '../functions/getMonthlyExpensesCalculations';


function AffordabilityStepMonthlyExpenses({
    onToggleExpand,
    stepNumber,
    title,
    ...otherProps
}) {
    const form = useForm();
    const { selectedMonthlyExpenseOption } = form.values;

    const formulas = useMemo(() => getFormulas(selectedMonthlyExpenseOption), [ selectedMonthlyExpenseOption ]);

    return (
        <>
            <FormComputed
                name="monthlyExpenses"
                value={getMonthlyExpenses}
            />

            <CalculatorStepAccordion
                title={title}
                stepNumber={stepNumber}
                onToggleExpand={onToggleExpand}
                showBadge={false}
                value="monthlyExpenses"
                valueFormat="CAD0"
                {...otherProps}
            >
                <CalculationPanel
                    title={(
                        <FormattedMessage
                            id="mtg-calculators.AffordabilityStepMonthlyExpenses.calculationPanelTitle"
                            defaultMessage="Calculate your monthly expenses"
                        />
                    )}
                >
                    <CalculationLineBlock
                        formulas={formulas}
                    />
                </CalculationPanel>
            </CalculatorStepAccordion>
        </>
    );
}

AffordabilityStepMonthlyExpenses.propTypes = {
    stepNumber: PropTypes.number.isRequired,
    title: MessagePropType.isRequired,

    onToggleExpand: PropTypes.func,
};

AffordabilityStepMonthlyExpenses.defaultProps = {
    onToggleExpand: undefined,
};

function getFormulas() {
    const calculations = getMonthlyExpensesCalculations({
        mortgagePaymentName: 'maxMortgagePayment',
        locationName: 'futureHomeLocation',
    });

    return [
        calculations.mortgagePaymentCalculation,
        calculations.propertyTaxCalculation,
        calculations.monthlyDebtCalculation,
        calculations.utilitiesCalculation,
        calculations.propertyInsuranceCalculation,
        calculations.phoneCalculation,
        calculations.cableCalculation,
        calculations.internetCalculation,
        calculations.monthlyExpensesCalculation,
    ];
}

export default styled(observer(AffordabilityStepMonthlyExpenses))`
    .scenarioChooser {
        border-bottom: 1px solid ${Colours.STONE};
    }
`;

